import btn from './index.vue'
const DrillLink = {
    install: function (Vue) {
        Vue.component('DrillLink', btn)
    }
}
export default DrillLink
